import styled from 'styled-components'
import { CARD_STYLED_PROPS } from './interface'

export const CardDiv = styled.div<CARD_STYLED_PROPS>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  //dynamic styles
  box-shadow: ${({ shadow }) => shadow || '0 10px 20px 0 rgba(0, 0, 0, 0.4)'};
  height: ${({ height }) => height || '86px'};
  width: ${({ width }) => width || '58px'};
  background: ${({ background, customProp }) =>
    customProp ? '#ffb000' : background || 'rgba(231, 226, 222, 1)'};
  border-radius: ${({ corner }) => corner || '9px'};
  padding: ${({ pad }) => pad || '12px'};
  margin: ${({ marg }) => marg || 'auto 0'};
  p {
    font-size: ${({ size }) => size || '31px'};
    color: ${({ suitColor }) => suitColor};
    line-height: ${({ lineHeight }) => lineHeight || '1.4'};
  }
  svg {
    min-height: ${({ suitSize }) => suitSize || '26px'};
    min-width: ${({ suitSize }) => suitSize || '24px'};
    path {
      fill: ${({ suitColor }) => suitColor};
    }
  }
`
